// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"268447d2","161":"94056d09","290":"cc1dc3b5","344":"2540c93c","392":"687efbe9","490":"af7fa75b","493":"bd372b04","939":"38c9394f"}[chunkId] + ".chunk.css";
};